import { 
    CreateVehicleDto, 
    DeleteVehicleDto,
    EditVehicleDto,
    GetVehicleDto, 
    MessageResponseDto, 
    VehicleApiFp,
    VehicleControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseVehicleModel = VehicleControllerGet200Response;
export type GetVehicleModel = GetVehicleDto;
export type MutateResponseVehicleModel = MessageResponseDto;
export type CreateVehicleModel = CreateVehicleDto;
export type UpdateVehicleModel = EditVehicleDto;
export type DeleteVehicleModel = DeleteVehicleDto;

export interface CreateVehicleModelExtension {
  vehicle: CreateVehicleModel;
  file: File;
}

export interface UpdateVehicleModelExtension {
  vehicle: UpdateVehicleModel;
  file: File;
}

export const apiVehicleFp = VehicleApiFp(apiConfig);
export const getVehicleController = apiVehicleFp.vehicleControllerGet;
export const getVehicleByCardSeriesController = apiVehicleFp.vehicleControllerGetVehicleByCardSeries;
export const createVehicleController = apiVehicleFp.vehicleControllerCreate;
export const updateVehicleController = apiVehicleFp.vehicleControllerEdit;
export const deleteVehicleController = apiVehicleFp.vehicleControllerDelete;

export const QueryKeyVehicle = QueryKey.Vehicle;
